import { render, staticRenderFns } from "./SettingsAutoresponder.vue?vue&type=template&id=529aafbc&"
import script from "./SettingsAutoresponder.vue?vue&type=script&lang=js&"
export * from "./SettingsAutoresponder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports